import { Form, Typography } from 'antd'
import useUpdateBusiness from 'pages/building/tourViewerPage/hook/Extra/useUpdateBusiness'
import Validators from 'utils/validators'

import Button from 'components/atoms/Button'
import Modal from 'components/atoms/Modal'
import Spinner from 'components/atoms/Spinner'
import Title from 'components/atoms/Title'

export default function ModalSettingBusiness({
  handleCancel
}: {
  handleCancel: () => void
}) {
  const {
    t,
    form,
    inputRef,
    quillRef,
    businessLogoImage,
    handleSaveBusiness,
    handleChooseFile,
    handleFileChange,
    handleDeleteBusiness,
    isLoading,
    updating,
    deleting,
    isLoadingInitData,
    isSavingData
  } = useUpdateBusiness({ handleCancel })

  return (
    <Modal className="modal-custom" width={700} rootClassName="">
      <Title
        title={t('building.businessSetting.title')}
        bottomMargin="mb-[31px]"
      />

      <Form form={form} colon={false} onFinish={handleSaveBusiness}>
        <Spinner
          spinning={
            isLoading ||
            updating ||
            deleting ||
            isLoadingInitData ||
            isSavingData
          }
        >
          {/* Image */}
          <div>
            {/* Image */}
            <div className="flex justify-between items-center gap-x-4">
              <Typography.Text>
                {t('building.businessSetting.image_title')}
              </Typography.Text>

              {/* div show image selected  */}
              <Form.Item
                name="businessImageWrapper"
                dependencies={['businessImage']}
                hasFeedback
                className="logo-upload !mb-0"
              >
                <div onClick={handleChooseFile} className="ml-16">
                  {businessLogoImage ? (
                    <img
                      className="max-h-[118px] object-contain bg-[#021120]"
                      src={businessLogoImage}
                      alt="businessLogoImage"
                      loading="eager"
                    />
                  ) : (
                    <Typography.Text>
                      {t('building.noImageNote')}
                    </Typography.Text>
                  )}
                </div>
              </Form.Item>
              <div className="flex flex-col gap-y-[2px] items-center mt-10">
                <div>
                  <div className="flex flex-col justify-center items-center">
                    <Typography
                      onClick={handleChooseFile}
                      className="bg-[#B3CFCB] mt-2 p-2 w-12 rounded-[10px] cursor-pointer hover:opacity-80"
                    >
                      {t('building.chooseLogoFileBtn')}
                    </Typography>
                    <div className="text-[10px] font-[400px] pt-2">
                      {t('building.fileSizeNote')}
                    </div>
                  </div>

                  <Form.Item
                    name="businessImage"
                    className="mb-0"
                    rules={[
                      {
                        validator: Validators.validateFileSize(t, 50)
                      }
                    ]}
                  >
                    <div className="hidden" />
                  </Form.Item>

                  <input
                    accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
                    type="file"
                    ref={inputRef}
                    onChange={handleFileChange}
                    hidden
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Text Editor */}

          <div className="h-[300px] mt-[30px] mb-[80px]">
            <div
              ref={quillRef}
              className="quill-custom-editor overflow-hidden [&>#editor-resizer>.toolbar]:!hidden [&>.ql-editor]:pb-10"
            />
          </div>
        </Spinner>
        {/* Action area */}
        <div className="flex gap-10 justify-center mt-10">
          {/* Button delete */}
          <Button
            onClick={handleDeleteBusiness}
            sizing="w-[140px] h-[50px]"
            className="bg-[#B80808]"
          >
            {t('common.delete')}
          </Button>
          {/* Button cancel */}
          <Button sizing="w-[140px] h-[50px]" onClick={handleCancel}>
            {t('building.buttonCancel')}
          </Button>
          {/* Button save */}
          <Button htmlType="submit" type="primary" sizing="w-[140px] h-[50px]">
            {t('building.buttonSave')}
          </Button>
        </div>
      </Form>
    </Modal>
  )
}
